import { FlatViewOrderSinglePageDesktop, ICallbackParams } from '@cian/newbuilding-flat-view-order-component';
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { trackFlatViewOrderPopupOpen, trackFlatViewOrderSuccess } from './tracking';
import { addFlatTourBooking } from '../../../browser/services/flatTourBooking/addFlatTourBooking';
import { FlatViewButton, FlatViewButtonCollapsed } from '../../components/FlatViewButton';
import { canMakeFlatViewOrder, getOfferUserId } from '../../selectors';
import { getIsFlatTourAvailable, getFlatTourSchedule } from '../../selectors/flatTourBooking';
import { getNewbuildingId, getNewbuildingName } from '../../selectors/newObject';

interface IFlatViewButtonContainerProps {
  collapsed?: boolean;
}

export function FlatViewButtonContainer({ collapsed }: IFlatViewButtonContainerProps) {
  const [isBookingWidgetOpened, setIsBookingWidgetOpen] = React.useState(false);

  const dispatch = useDispatch();
  const isEnabled = useSelector(canMakeFlatViewOrder);
  const isTourAvailable = useSelector(getIsFlatTourAvailable);
  const newbuildingName = useSelector(getNewbuildingName);
  const newbuildingId = useSelector(getNewbuildingId);
  const builderUserId = useSelector(getOfferUserId);
  const schedule = useSelector(getFlatTourSchedule);

  const handleOpenModal = React.useCallback(() => {
    trackFlatViewOrderPopupOpen();
    setIsBookingWidgetOpen(true);
  }, []);

  const handleCloseModal = React.useCallback(() => {
    setIsBookingWidgetOpen(false);
  }, []);

  const handleSubmit = React.useCallback(
    async (params: ICallbackParams) => {
      try {
        const bookingParams = {
          newbuildingId: newbuildingId as number,
          builderUserId: builderUserId as number,
          fullName: params.name,
          phone: params.phone,
          tourTime: `${params.date} ${params.time}`,
        };

        // eslint-disable-next-line @typescript-eslint/await-thenable
        await dispatch(addFlatTourBooking(bookingParams));

        return true;
      } catch {
        return false;
      }
    },
    [dispatch, builderUserId, newbuildingId],
  );

  const handleSuccessSubmit = React.useCallback((params: ICallbackParams) => {
    trackFlatViewOrderSuccess(params);
  }, []);

  if (!isEnabled) {
    return null;
  }

  const ButtonComponent = collapsed ? FlatViewButtonCollapsed : FlatViewButton;

  return (
    <>
      <ButtonComponent onClick={handleOpenModal} disabled={!isTourAvailable} />
      {schedule && (
        <FlatViewOrderSinglePageDesktop
          isOpen={isBookingWidgetOpened}
          onClose={handleCloseModal}
          onSuccess={handleSuccessSubmit}
          onSubmit={handleSubmit}
          newbuildingName={`ЖК «${newbuildingName}»`}
          nextDate={schedule.nextDate}
          nextNextDate={schedule.nextNextDate}
          availableDates={schedule.availableDates}
          disabledDays={schedule.disabledDays}
          minDate={schedule.minDate}
          maxDate={schedule.maxDate}
        />
      )}
    </>
  );
}
